import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { ISelfReturnRequest } from '../../interfaces/return-list/self-return-request.interface';
import { AbstractReturnPaymentService } from '../abstraction/abstract.return-payment.service';

@Injectable({
  providedIn: 'root',
})
export class ReturnPaymentService extends AbstractReturnPaymentService {
  private controller = `/manager/returnpayment`;
  private urlGetReturnPaymentReasonCodeList = `${environment.apiUrl}${this.controller}/returnpaymentreasoncodelist`;
  private urlPostSendSelfReturn = `${environment.apiUrl}${this.controller}/sendselfreturn`;

  constructor(private http: HttpClient) {
    super();
  }

  returnPaymentReasonCodeList(): Promise<any> {
    return this.http
      .get<any>(`${this.urlGetReturnPaymentReasonCodeList}`)
      .toPromise()
      .then(res => res)
      .then(data => data);
  }

  sendSelfReturn(selfReturnRequest: ISelfReturnRequest): Promise<IWebMessage | undefined> {
    return this.http
      .post<IWebMessage>(`${this.urlPostSendSelfReturn}`, selfReturnRequest)
      .toPromise();
  }
}
